"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error("[global-error]", error);
  }, [error]);

  return (
    <html lang="ko">
      <body style={{ margin: 0, background: "#ffffff", color: "#111827" }}>
        <main
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: "440px" }}>
            <h1 style={{ fontSize: "21px", margin: 0 }}>
              애플리케이션을 다시 불러와야 합니다
            </h1>
            <p style={{ color: "#6b7280", fontSize: "14px", lineHeight: 1.65, margin: "12px 0 24px" }}>
              화면 코드가 갱신되었거나 예상하지 못한 오류가 발생했습니다.
              다시 시도해도 복구되지 않으면 페이지를 새로 불러와주세요.
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center" }}>
              <button
                type="button"
                onClick={() => unstable_retry()}
                style={{
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  color: "#374151",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                  padding: "10px 16px",
                }}
              >
                다시 시도
              </button>
              <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                  background: "#2563eb",
                  border: 0,
                  borderRadius: "12px",
                  color: "#ffffff",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                  padding: "10px 16px",
                }}
              >
                페이지 새로 불러오기
              </button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
